"use client";

import Logo from "@/common/Logo";
import LanguageSelector from "./components/LanguageSelector";
import { usePathname } from "next/navigation";
import Link from "next/link";
import { useTranslation } from "react-i18next";
import { NAV_ITEMS } from "./constants";
import useHeader from "./hooks/useHeader";

const sectionIds = NAV_ITEMS.map((item) => item.href);

const Header = () => {
  const pathname = usePathname();
  const { t } = useTranslation();
  const { isTop, activeSection, handleNavClick } = useHeader(sectionIds);

  return (
    <header
      className={`fixed min-h-12 h-fit top-0 left-0 w-screen z-20 py-2 px-4 md:px-15 transition-colors duration-300 ${isTop ? "bg-white/20 border-b border-white/50" : "bg-white border-b border-slate-200/50"} flex justify-between items-center`}
    >
      <div className="w-full grid grid-cols-[10rem_1fr_auto] items-center">
        <Logo />

        {pathname === "/" ? (
          <nav className="hidden xl:flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.href}
                href={`#${item.href}`}
                onClick={(e) => handleNavClick(e, item.href)}
                className={`inline-flex items-center font-[600] text-[0.875rem] transition-colors duration-300 ${activeSection === item.href ? "text-blue-500" : isTop ? "text-white hover:text-blue-400" : "text-gray-800 hover:text-gray-900"}`}
                suppressHydrationWarning
              >
                {t(item.label)}
              </a>
            ))}
          </nav>
        ) : null}

        <div className="flex items-center justify-end md:gap-6">
          <div className="hidden md:block">
            <Link
              href="/newsroom"
              className={`font-[600] text-[0.875rem] px-4 py-1 rounded-full border transition-colors duration-300 ${pathname === "/newsroom" ? "text-blue-500 border-blue-500" : isTop ? "text-white border-white hover:text-white/80" : "text-gray-800 border-gray-300 hover:text-gray-900"}`}
              suppressHydrationWarning
            >
              {t("HEADER_NEWSROOM")}
            </Link>
          </div>

          <LanguageSelector isTop={isTop} />
        </div>
      </div>
    </header>
  );
};

export default Header;
